import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.sampling;

export default class Sampling extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.increment(1),
      unique_id: this.string(''),
      name: this.attr(''),
      code: this.attr(''),
      produced_value: this.number(0),
      sampled_value: this.number(0),
      unallocated_value: this.number(0),
      needed_for_deps_value: this.number(0),
      dlc: this.number(0),
      packages: this.attr([]),
      production_date: this.attr(null),
      component_id: this.number(null),
      component_type: this.string(''),
    };
  }
}
